/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { createColumnHelper } from "@tanstack/react-table";
import { Text, theme } from "@nordcloud/gnui";
import { ResourceReportPackage } from "~/generated/graphql";
import { LargeColumn } from "~/components/Tables/styles";

const columnHelper = createColumnHelper<ResourceReportPackage>();

export function columns() {
  return [
    columnHelper.accessor("name", {
      header: "Update Name",
      cell: ({ row }) => {
        const name = row.original.name;
        const version = row.original.version;

        return (
          <Text tag="div" color={theme.color.text.text01}>
            {name}
            {version ? ` (${version})` : ""}
          </Text>
        );
      },
      meta: LargeColumn,
    }),
  ] as never;
}
